module.exports = __webpack_public_path__ + "img/fog.9753bbe4.jpg";